import React from 'react';
import {
  createSocialLoginState,
  rememberSocialLoginFlow,
  resolveSocialLoginSource,
} from './SocialLoginUtils.js';

const NAVER_CLIENT_ID = "CTLHJNvocVtJYks1UrYT"

const NaverLogin = ({ successCallback, failCallback, source }) => {
  const login = () => {
    const resolvedSource = resolveSocialLoginSource(source)
    const state = createSocialLoginState({
      successCallback,
      failCallback,
      source: resolvedSource,
    })
    const redirectUri = encodeURIComponent(window.location.origin + `/auth/callback/naver`)

    rememberSocialLoginFlow(state, {
      successCallback,
      failCallback,
      source: resolvedSource,
    })

    window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}`
  }

  return (
    <button type='button' className='social-login-button social-login-button--naver' onClick={login}>
      <span className='social-login-icon social-login-icon--naver' aria-hidden='true'>N</span>
      <span>네이버로 시작하기</span>
      <span className='social-login-arrow' aria-hidden='true'>›</span>
    </button>
  )
}

export default NaverLogin
